export const getCurrentUserCount = (tenant) => {
  const currentUsers = tenant?.users?.length || 0;
  if (!Number.isFinite(tenant?.allowedUsers)) {
    return `${currentUsers}/unbegrenzt`;
  }
  return `${currentUsers}/${tenant?.allowedUsers.toString()}`;
};

export const allowNewUser = (tenant) => {
  const currentUsers = tenant?.users?.length || 0;
  if (!Number.isFinite(tenant?.allowedUsers)) return true;
  return currentUsers < tenant?.allowedUsers;
};

export const getCurrentSitesCount = (tenant) => {
  if (!Number.isFinite(tenant?.allowedSites)) {
    return `${tenant?.sites?.length}/unbegrenzt`;
  }
  return `${tenant?.sites?.length}/${tenant?.allowedSites.toString()}`;
};

export const allowNewSite = (tenant) => {
  if (!Number.isFinite(tenant?.allowedSites)) return true;
  let allow = true;
  if (tenant?.sites?.length === tenant?.allowedSites) allow = false;
  return allow;
};
